import logoMarkup from "../assets/backstage-logo.svg?raw";

interface LogoProps {
  /** Height drives the size, width follows the aspect ratio (e.g. `h-5`). */
  className?: string;
  label?: string;
  decorative?: boolean;
}

/**
 * The Backstage wordmark. The SVG is inlined into the DOM (not an <img>) and its
 * fills use `currentColor`, so the wrapper's color — the theme-aware
 * `--color-logo` token vendored from memex-ai (dec-9) — recolours it with the
 * `.light`/`.dark` class on `<html>`. Same mechanism as the core app's Logo.
 */
export function Logo({ className, label = "Memex Backstage", decorative = false }: LogoProps) {
  return (
    <span
      data-testid="backstage-logo"
      role={decorative ? undefined : "img"}
      aria-label={decorative ? undefined : label}
      aria-hidden={decorative || undefined}
      style={{ color: "rgb(var(--color-logo))" }}
      className={`inline-flex items-center [&>svg]:block [&>svg]:h-full [&>svg]:w-auto${
        className ? ` ${className}` : ""
      }`}
      dangerouslySetInnerHTML={{ __html: logoMarkup }}
    />
  );
}

export default Logo;
